import { authApiService } from '@/api/authApiService';
import { ApiResponseType, RequestOptions } from '@/types/sharedTypes';
import {
  RecipientRequestType,
  RequestAudienceType,
  RequestExpiryType,
  RequestModeType,
  RequestTypeType,
  RequestViaType,
} from '@/types/vendorVaultTypes';

export type CreateRecipientRequestPayloadType = {
  request_type: RequestTypeType;
  bank: string | null;
  recipient_name: string;
  mode: RequestModeType;
  audience: RequestAudienceType;
  via: RequestViaType;
  sent_to: string;
  expiry_code: RequestExpiryType;
  wire_confirmation: boolean;
  detailed: boolean;
};

export const createRecipientRequestApi = (
  data: CreateRecipientRequestPayloadType,
  options: RequestOptions
): Promise<ApiResponseType<RecipientRequestType>> =>
  authApiService.POST('/vendor-vault/requests/create/', data, null, options);
